import Cookies from 'js-cookie';

/**
 * Modal.js.
 *
 */

const modals = {
  // Notices Modal
  initNoticesModal: () => {
    if (document.getElementById('id-modal-notices')) {
      //get our modal and the close buttons
      const modalNotices = document.querySelector('.modal-notices');
      const modalCloseNotices = document.querySelectorAll('.close-modal-notices');

      //define our close function
      const closeModal = () => modalNotices.classList.remove('active');

      modalCloseNotices.forEach((element) => {
        //close click listeners:
        element.addEventListener('click', (e) => {
          e.preventDefault();
          closeModal(); // call our close function
        });
        // close key listeners:
        element.addEventListener('keyup', (e) => {
          if (e.keyCode === 13 || event.keyCode === 32) {
            e.preventDefault();
            closeModal(); // call our close function
          }
        });
      });

      //get cookie value
      const noticesCookieValue = Cookies.get('noticesCookie');

      //get data attribute id
      const modalAttributeValue = document.getElementById('id-modal-notices');
      const noticesAttributeValue = modalAttributeValue.getAttribute('data-value');

      //Check if the attribute value equals our current cookie value
      if (noticesCookieValue !== noticesAttributeValue) {
        //after a 1s delay modal will be displayed and cookie set to new value
        setTimeout(function () {
          Cookies.set('noticesCookie', noticesAttributeValue, { expires: 2 });
          modalNotices.classList.add('active');
        }, 1000);
      }
    }
  },

  // Open Terms and Conditions in Modal on menu item click
  initTermsModal: () => {
    const terms = document.querySelector('.terms-link');
    const modalTerms = document.querySelector('.modal-terms');

    //open terms modal when link with specified class clicked
    terms.addEventListener('click', (e) => {
      e.preventDefault();
      // if active is set remove it, otherwise add it
      const handleToggleTerms = () => modalTerms.classList.toggle('active');
      handleToggleTerms();
    });

    //get the close buttons
    const modalCloseTerms = document.querySelectorAll('.close-modal-terms');

    //define our close function
    const closeModal = () => modalTerms.classList.remove('active');

    modalCloseTerms.forEach((element) => {
      //close click listeners:
      element.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal(); // call our close function
      });
      // close key listeners:
      element.addEventListener('keyup', (e) => {
        if (e.keyCode === 13 || event.keyCode === 32) {
          e.preventDefault();
          closeModal(); // call our close function
        }
      });
    });
  },

  // Open After Hours in Modal on menu item click
  initAfterHoursModal: () => {
    const afterHours = document.querySelectorAll('.after-hours-link');
    const modalAfterHours = document.querySelector('.modal-after-hours');

    afterHours.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        // if active is set remove it, otherwise add it
        const handleToggleAfterHours = () => modalAfterHours.classList.toggle('active');
        handleToggleAfterHours();
      });
    });

    //get the close buttons
    const modalCloseAfterHours = document.querySelectorAll('.close-modal-after-hours');

    //define our close function
    const closeModal = () => modalAfterHours.classList.remove('active');

    modalCloseAfterHours.forEach((element) => {
      //close click listeners:
      element.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal(); // call our close function
      });
      // close key listeners:
      element.addEventListener('keyup', (e) => {
        if (e.keyCode === 13 || event.keyCode === 32) {
          e.preventDefault();
          closeModal(); // call our close function
        }
      });
    });
  },
};

export default modals;
